import { useSelector } from 'react-redux';

const useGetQuoteHealthDetails = () => {
    return useSelector((state) => state.quoteHealthDetails.details);
};

export default useGetQuoteHealthDetails;